
namespace GeniuzPOS.PosShift {

    @Serenity.Decorators.registerClass()
    export class PsPriceOverrideTranDialog extends Serenity.EntityDialog<PsPriceOverrideTranRow, any> {
        protected getFormKey() { return PsPriceOverrideTranForm.formKey; }
        protected getIdProperty() { return PsPriceOverrideTranRow.idProperty; }
        protected getLocalTextPrefix() { return PsPriceOverrideTranRow.localTextPrefix; }
        protected getNameProperty() { return PsPriceOverrideTranRow.nameProperty; }
        protected getService() { return PsPriceOverrideTranService.baseUrl; }
        protected getDeletePermission() { return PsPriceOverrideTranRow.deletePermission; }
        protected getInsertPermission() { return PsPriceOverrideTranRow.insertPermission; }
        protected getUpdatePermission() { return PsPriceOverrideTranRow.updatePermission; }

        protected form = new PsPriceOverrideTranForm(this.idPrefix);

    }
}